export default __webpack_public_path__ + "static/lufthansa-bebdcaf55c4f984ea8729a003ef227a9.png";